import { createUseDateRangeFilter } from '@/creditflowresearch/ui/common/hooks/sidebar/useDateRangeFilter';
import {
  useCorporateBondScreenerSidebarFilterContext,
} from '@/creditflowresearch/application/CorporateBondScreener/Sidebar/useCorporateBondScreenerSidebarFilterContext';

const useDateRangeFilter = createUseDateRangeFilter(useCorporateBondScreenerSidebarFilterContext);

const useMaturityDate = () => {
  const { filters } = useCorporateBondScreenerSidebarFilterContext();

  return useDateRangeFilter({
    fromKey: 'includedMaturityDateFrom',
    toKey: 'includedMaturityDateTo',
    bounds: filters?.maturityDate,
  });
};

export default useMaturityDate;
